import React, { useEffect, useState } from 'react';
import { getMostRead, getUploadUrl } from '../services/api';
import useFadeIn from '../hooks/useFadeIn';
import '../css/sections.css';

const FALLBACK = [
  { _id: '1', title: 'Most Inspiring Women Leaders Revamping the Future, 2024', category: 'Global Business Leaders', imageUrl: 'https://images.pexels.com/photos/6950093/pexels-photo-6950093.jpeg' },
  { _id: '2', title: 'The Most Empowering Women Leader to Watch in 2026', category: 'Women In Business', imageUrl: 'https://images.unsplash.com/photo-1731848358154-52ebc3c4d590?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
  { _id: '3', title: 'The Most Successful Business Leaders to Watch in 2024', category: 'Business Leaders', imageUrl: 'https://images.unsplash.com/photo-1610251064409-8d94b0939629?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fFRoZSUyME1vc3QlMjBTdWNjZXNzZnVsJTIwQnVzaW5lc3MlMjBMZWFkZXJzJTIwdG8lMjBXYXRjaCUyMGluJTIwMjAyNHxlbnwwfHwwfHx8MA%3D%3D' },
  { _id: '4', title: 'The Most Impactful Leader In Education Sector 2025', category: 'Leadership', imageUrl: 'https://images.unsplash.com/photo-1650784854945-264d5b0b6b07?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
  { _id: '5', title: 'Most Iconic Women Leaders to Watch in 2025', category: 'Global Business Leaders', imageUrl: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=140&h=100&fit=crop&q=80' },
  { _id: '6', title: 'Most Influential Women Leaders to Watch in 2024', category: 'Global Business Leaders', imageUrl: 'https://plus.unsplash.com/premium_photo-1771899705194-57020f4773ff?q=80&w=1332&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
  { _id: '7', title: 'The Most Innovative Leader in Advanced Clinical Medicine – 2026', category: 'Medicine', imageUrl: 'https://plus.unsplash.com/premium_photo-1681967011376-5196197ed473?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mjl8fE1lZGljaW5lJTIwVGhlJTIwTW9zdCUyMElubm92YXRpdmUlMjBMZWFkZXIlMjBpbiUyMEFkdmFuY2VkJTIwQ2xpbmljYWwlMjBNZWRpY2luZSUyMCVFMiU4MCU5MyUyMDIwMjZ8ZW58MHx8MHx8fDA%3D' },
  { _id: '8', title: '8 Proven Strategies for Fostering Innovative Leadership', category: 'Leadership', imageUrl: 'https://images.unsplash.com/photo-1637296493609-2997fa306138?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fE1vc3QlMjBJbnNwaXJpbmclMjBXb21lbiUyMExlYWRlcnMlMjBSZXZhbXBpbmclMjB0aGUlMjBGdXR1cmUlMkMlMjAyMDI0fGVufDB8fDB8fHww' },
  { _id: '9', title: 'The Most Visionary Business Leader To Watch In 2026', category: 'Global Business Leaders', imageUrl: 'https://images.unsplash.com/photo-1561491432-82f2b22a263e?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
  { _id: '10', title: 'Most Influential Business Innovators to Watch in 2024–25', category: 'Business Leaders', imageUrl: 'https://images.unsplash.com/photo-1769798643630-194a0fcfa367?q=80&w=1182&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
];

export default function Articles() {
  const [articles, setArticles] = useState(FALLBACK); // pre-populate
  const ref = useFadeIn(true);

  useEffect(() => {
    getMostRead()
      .then(r => {
        const data = r.data?.data;
        if (data?.length) setArticles(data);
      })
      .catch(() => {/* keep FALLBACK */ });
  }, []);

  return (
    <section className="sec sec-mid" id="most-read" ref={ref}>
      <div className="wrap">
        <h2
          className="sec-title fade-in"
          style={{ display: 'block', marginBottom: 0 }}
        >
          Most Read This Week
        </h2>

        {/* FIX #19: removed padding-left hover transition from ritem.
            It causes permanent layout shift on touch devices. Background
            colour change only. See sections.css .ritem rule. */}
        <div className="read-grid" role="list">
          {articles.map((a, i) => (
            <article key={a._id} className="ritem fade-in" role="listitem">
              <span className="rnum" aria-hidden="true">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="rthumb" aria-hidden="true">
                <img
                  src={getUploadUrl(a.imageUrl)}
                  alt=""
                  loading="lazy"
                  width="78"
                  height="58"
                  onError={e => { e.target.style.display = 'none'; }}
                />
              </div>
              <div className="rinfo">
                <span className="rtag">{a.category}</span>
                <h3><a href="#">{a.title}</a></h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
